import * as React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ExploreOffOutlined } from '@mui/icons-material';
import { MainPadding } from '../components/MainPadding';

const HomeLink = React.forwardRef((props: any, ref: any) => (
    <Link to="/" ref={ref} {...props} />
));

export class NotFound extends React.Component<any, any> {
    public render() {
        return (
            <MainPadding>
                <Box
                    sx={{
                        marginTop: 6,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        padding: { xs: 4, md: 7 },
                        borderRadius: '22px',
                        position: 'relative',
                        overflow: 'hidden',
                        background:
                            'radial-gradient(800px 400px at 20% -30%, rgba(5, 35, 114, 0.10), transparent 60%),' +
                            'radial-gradient(700px 400px at 100% 20%, rgba(250, 135, 28, 0.08), transparent 60%),' +
                            'rgba(255, 255, 255, 0.92)',
                        border: '1px solid rgba(11, 18, 48, 0.06)',
                        boxShadow: '0 1px 2px rgba(11, 18, 48, 0.04), 0 18px 40px -16px rgba(5, 35, 114, 0.18)',
                    }}
                >
                    <Typography
                        className="eyebrow"
                        sx={{ color: 'text.secondary' }}
                    >
                        404 · not found
                    </Typography>
                    <Box
                        sx={{
                            mt: 2,
                            width: 72,
                            height: 72,
                            borderRadius: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'linear-gradient(180deg, rgba(5, 35, 114, 0.10) 0%, rgba(5, 35, 114, 0.04) 100%)',
                            border: '1px solid rgba(5, 35, 114, 0.10)',
                            color: 'primary.main',
                        }}
                    >
                        <ExploreOffOutlined sx={{ fontSize: 32 }} />
                    </Box>
                    <Typography
                        sx={{
                            mt: 3,
                            fontFamily: '"Inter Tight", "Inter", sans-serif',
                            fontWeight: 700,
                            letterSpacing: '-0.022em',
                            fontSize: { xs: 36, md: 48 },
                            lineHeight: 1.05,
                        }}
                    >
                        We couldn't find that page.
                    </Typography>
                    <Typography sx={{ mt: 1.5, color: 'text.secondary', maxWidth: 480, lineHeight: 1.6 }}>
                        The link may be stale, the website may have been removed, or the URL was mistyped. Head home to pick up where you left off.
                    </Typography>
                    <Button component={HomeLink} variant="contained" size="large" sx={{ mt: 4 }}>
                        Back home
                    </Button>
                </Box>
            </MainPadding>
        );
    }
}
